// ## SPACESHIPS
export const CURRENCIES = { W: 'WAX', B: 'BOOM', F: 'FOOD', G: 'GAS', M: 'MARS', D: 'DOOM' };
